/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';
import { Grid } from '../UNSAFE_Grid';

export type Props = {
  /**
   *The children are StepButtons.
   */
  children: ComponentChildren;
};

// TODO: Replace Steppers with Buttonset when it becomes available
export function Steppers({ children }: Props) {
  return (
    <Grid align="center" gap="1x" gridTemplateColumns="1fr 1fr">
      {children}
    </Grid>
  );
}
